<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>配置管理</el-breadcrumb-item>
      <el-breadcrumb-item>表单字段</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel">
          <!-- <div class="panel-heading">
              <h3 class="panel-title">{{ $route.meta.name }}列表</h3>
            </div> -->
          <div class="">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane
                v-for="(item, tIndex) in tabs"
                :label="item.name"
                :name="item.id"
                :key="item.id"
              >
                <el-tag
                  :key="tag.name"
                  v-for="(tag, index) in params"
                  closable
                  :disable-transitions="false"
                  @close="handleClose(tag, index)"
                >
                  {{ tag.name }}
                </el-tag>
                <el-input
                  class="input-new-tag"
                  v-if="inputVisible"
                  v-model="inputValue"
                  ref="saveTagInput"
                  size="small"
                  @keyup.enter.native="handleInputConfirm"
                  @blur="handleInputConfirm"
                >
                </el-input>
                <el-button
                  v-else
                  class="button-new-tag"
                  size="small"
                  :key="activeName"
                  @click="showInput(tIndex)"
                  >+ 添加</el-button
                >
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  formParamList,
  formParamCreate,
  formParamDelete,
} from '@/service/getData'

const params = [
  {
    id: '1',
    name: '规格',
  },
]

export default {
  data() {
    return {
      tabs: params,
      activeName: params[0].id,
      loading: false,
      params: [],
      inputVisible: false,
      inputValue: '',
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async handleClose(tag, index) {
      let res = await formParamDelete(tag.id)
      if (res.status == 0) {
        this.params.splice(index, 1)
      }
    },

    showInput(index = 0) {
      this.inputVisible = true
      this.$nextTick((_) => {
        this.$refs.saveTagInput[index].$refs.input.focus()
      })
    },

    async handleInputConfirm() {
      let inputValue = this.inputValue
      if (inputValue) {
        let res = await formParamCreate({
          name: inputValue,
          category: parseInt(this.activeName),
        })
        if (res.status == 0) {
          this.params.push(res.data)
        }
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    handleClick(tab, event) {
      this.params = []
      this.activeName = tab.name
      this.inputVisible = false
      this.inputValue = ''
      this.getData()
    },
    async getData() {
      this.loading = true
      let res = await formParamList({
        category: parseInt(this.activeName),
        size: 200,
      })
      if (res.status != 0) return false
      this.params = res.data.list
      this.loading = false
    },
  },
}
</script>

<style>
.el-tag {
  margin-right: 10px;
  margin-bottom: 10px;
}
.button-new-tag {
  /* margin-left: 10px; */
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  margin-bottom: 10px;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  margin-bottom: 10px;
  vertical-align: bottom;
}
</style>